module.exports = {
  "FoodC_bill_VODO_nrnN": "累计已省",
  "FoodC_C_Detailed_rules_WfnL": "详细规则",
  "FoodC_birthday_nxQg_feGV": "剩余次数：{{n}}",
  "FoodC_unsubscription_moTV_YOeR": "我们将利用这些信息来改进会员服务。",
  "FoodD_optimization_lXdy_Scjt": "更多规则",
  "FoodC_update_mXRF_lKCK": "新增",
  "FoodC_update_YSxw_ZNzh": "第一个月",
  "FoodC_saverpack_Vsih_jLbN": "{{n}}张券已使用",
  "FoodC_shoprank_OYFZ_jaot": "详细规则",
  "FoodC_subscription_uipE_quiy": "返回",
  "FoodD_Gattaran_gaJp_rKSK": "被推荐人载具",
  "FoodC_membership_ootV_ZRYt": "与按月购买相比，额外节省{{percent}}。",
  "FoodC_V2_kGDN_zGcg": "开启订阅即表示您授权{{didifoodbrand}}于{{date}}自动扣除您{{money}}，并在之后每个月收取此金额。可随时取消订阅，取消时无需支付其他费用或罚金。{{rules}}",
  "FoodC_update_UDFM_jhpN": "无限次外卖免配送费",
  "FoodC_store_Store_Coupon_szoR": "商家券",
  "FoodC_Task_Congratulations_pDXl": "恭喜！",
  "FoodC_V2_RTeI_mEFs": "从{{date}}起，每个月会自动扣款{{money}}，可随时取消订阅。",
  "FoodC_CGC_Other_channel_oFak": "其他渠道邀请",
  "FoodC_membership_ZQog_oSjJ": "选择订阅方案",
  "FoodC_membership_XTeP_nLeJ": "按半年",
  "FoodC_Notifications_Invite_users_Ovxe": "邀请用户",
  "FoodC_C_Off_fkZy": "off",
  "FoodC_CGC_SaMA_ymHl": "本优惠活动仅限{{app_name}}[在线支付]的订单享受，不可提现转赠",
  "FoodC_birthday_UhuO_lUDL": "券领取失败，请稍后重试",
  "FoodOpB_account_Loading_EDDu": "加载中",
  "FoodC_CGC_XBGw_UVvR": "您邀请的好友必须是符合{{app_name}}活动规则的用户，每人仅限享受{{num}}次奖励，同一手机号、同一设备、同一支付账号视为同一用户",
  "FoodC_subscription_skWN_HfEE": "自动续费",
  "FoodC_update_QQlM_iHYO": "设置",
  "FoodC_side3_xeOS_SWLO": "{{name}}可用",
  "FoodC_pause_iXVD_owuh": "暂停结束后会自动重新加入{{brand}}，您将在{{date}}被扣款{{money}}。{{tc}}",
  "FoodC_unsubscription_tNxS_UdhI": "请选择原因",
  "FoodD_Gattaran_KYAP_kQnV": "1.邀请朋友注册",
  "FoodC_pause_Wukv_RhXR": "暂停自动扣费",
  "FoodC_subscription_StNY_sWmE": "完成购买则代表您同意{{rules}}。",
  "FoodB_V2_dLkl_pbiF": "客户端版本低，请更新版本再操作",
  "FoodC_membership_dmqk_wJgV": "按季度",
  "FoodC_cancellation_dfmf_HEyK": "您确定要取消{{conuntry}}的会员吗？",
  "FoodC_V1_Gift_box_UWqz": "你已经打开过这个礼盒了",
  "FoodC_C_Mission_completed_FkCw": "任务已完成",
  "FoodC_saverpack_hgwE_EIDA": "购买成功",
  "FoodC_url_reaV_LXaO": "去使用",
  "FoodC_update_wBxB_qtoB": "首月免费体验{{brand2}}，并开启订阅。您将授权{{didifoodbrand}}于接下来两个月自动扣款{{money1}}，再后来每个月自动扣款{{money2}},可随时取消订阅，取消时无需支付其他费用或罚金。{{rules}}",
  "FoodD_Activity_Completed_tPlA": "已结束",
  "FoodC_membership_fBAi_MQrN": "按月",
  "FoodC_update_VNPd_BxNP": "免费升级为{{brand1}}",
  "FoodC_CGC_qcLp_cjum": "本优惠活动仅限{{app_name}}邀请好友活动开通的区域，开通城市如下：{{city_list}}",
  "FoodC_cancellation_GzWi_eKHb": "订阅已取消",
  "FoodC_details_The_following_bPLC": "以下商家可使用",
  "FoodC_c_Please_try_cHSE": "请稍后再试",
  "FoodC_bill_QiYn_xBng": "省钱账单",
  "FoodC_C_View_Coupon_OIhv": "查看优惠券",
  "FoodC_1_Maximum_number_cJPy": "今日领取次数达上限",
  "FoodC_C_Received_DOQd": "已领取",
  "FoodC_pause_izJa_kTkD": "希望暂停自动扣费？",
  "FoodC_homepage_Unable_to_ybHC": "定位失败",
  "FoodC_CGC_KVtY_VNSE": "邀请好友在{{app_name}}下单，好友领取您送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，您均可获得价值{{amount}}的优惠券奖励",
  "FoodC_bill_Bspm_MYZN": "现在下单享受你的第一笔会员优惠",
  "FoodC_membership_Kgjx_NwXL": "开通按季度订阅",
  "FoodC_subscription_uwdO_LCcw": "加量包",
  "FoodD_optimization_Wiuc_vkvD": "邀请你的朋友",
  "soda-d-i18n---奖励详情": "奖励详情",
  "FoodC_2_Enter_mobile_jXbU": "输入手机号",
  "FoodC_register_cCpr_KUUG": "支付失败",
  "FoodC_words_vHza_gIgE": "加入{{brand}}{{money}}/月",
  "FoodC_C_No_coupon_DlRu": "无可使用券包",
  "FoodC_bill_xdYa_VuVu": "以下展示的订单明细不包含今日新增的会员优惠",
  "FoodC_cancellation_ulUw_bpyg": "管理其他国家会员",
  "FoodC_demand_Courier_purchasing_vPGD": "骑手代购",
  "FoodC_membership_SyjM_DiMe": "每月价格降低{{percent}}",
  "FoodC_update_faXs_YHbq": "加入时间",
  "FoodC_words_TYXi_ntMY": "之后{{money}}/月",
  "FoodC_CGC_WOQY_zerr": "收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码",
  "FoodC_unsubscription_EyKD_bpPY": "继续使用{{brand}}",
  "FoodC_update_KTVU_dCMP": "无限次",
  "soda-d-i18n---没有更多了": "没有更多了",
  "FoodC_V2_RUXY_aLKJ": "自动扣款支付方式",
  "FoodC_Notifications_Congratulations_you_qoKt": "恭喜你已经获得奖励",
  "FoodC_page_Your_invited_sPpR": "您邀请的好友必须是{{\t\nproductname_didi_food}}新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户",
  "FoodC_update_QaEe_FhNn": "{{money}}/月",
  "FoodC_C_Mission_Centre_HafM": "任务中心",
  "FoodC_subscription_CYiq_FQpm": "价格:{{money}}",
  "FoodC_page_Rewards_are_dWeY": "奖励按照【被推荐人】定位所在城市发放",
  "FoodC_C_Purchased_YheA": "已购买",
  "FoodC_membership_yQRX_Opwv": "当前包月会员有效期至{{date1}}，季度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money}}以订阅下一期季度会员。您可随时无责取消订阅。",
  "FoodC_saverpack_VKyf_NHhh": "{{money}}购买",
  "FoodC_update_HXID_CLBi": "购买历史",
  "FoodC_update_WqVL_CaFf": "更多权益",
  "FoodC_register_qELy_skhp": "尝试更换其他支付方式再次支付",
  "FoodC_membership_SafL_QGjc": "您需要现在支付{{money1}}。当前包月会员有效期至{{date1}}，年度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money2}}以订阅下一期年度会员。您可随时无责取消订阅。",
  "FoodC_rule_14_Up_dovx": "每个用户每天最多用券2张",
  "FoodC_C_Available_DlSP": "可使用",
  "sailing.d-api.common.活动时间": "活动时间",
  "FoodC_update_PJJg_EEDD": "接下来两个月",
  "FoodC_landingpage_hhPh_bwJS": "复制失败，请重试",
  "FoodOpC_city_Rewards_are_oURm": "奖励按照【被推荐人】定位所在城市发放",
  "FoodC_C_You_will_FoTj": "您将获得",
  "FoodC_page_The_threshold_yZFq": "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用",
  "FoodC_c_Sign_in_gRWz": "登录",
  "FoodC_Translation__brand_LAYp": "{{brand_name}} 优惠券",
  "FoodC_update_UnpB_Dwqt": "重新订阅时间",
  "FoodC_membership_iIPB_XJQE": "恭喜您开启半年度会员，将从{{date}}起正式生效。",
  "FoodC_membership_bNzP_hekS": "开通按半年订阅",
  "sailing.d-api.common.以上活动最终解释权归滴滴外卖所有": "以上活动最终解释权归滴滴外卖所有",
  "FoodC_update_KqNE_JARP": "免费使用{{brand1}}30天",
  "FoodC_subscription_gNZb_xfcd": "离开{{didipackbrand}}",
  "FoodC_page_XCBA_oZij": "订单",
  "FoodC_bill_DRvJ_yzMg": "闪送",
  "sailing.c-api-intl.超出配送范围": "超出配送范围",
  "FoodC_update_ErLg_Lrtz": "过期",
  "FoodC_birthday_uoAk_Rmzj": "点击这里查看优惠券",
  "FoodC_unsubscription_xxOV_zoQL": "您为什么希望取消订阅？",
  "FoodC_saverpack_FDoL_prPs": "开始使用",
  "FoodD_2_Single_amount_LbPB": "单量",
  "FoodD_optimization_WVNI_kCwK": "还剩{{day}}天{{hour}}小时邀请",
  "FoodC_cancellation_ivLi_DstK": "订阅已关闭",
  "FoodC_C_No_suitable_UnyN": "没有合适的活动",
  "FoodC_membership_mteQ_ejcJ": "{{money}}/月",
  "FoodC_membership_SrhP_uair": "恭喜您开启季度会员，将从{{date}}起正式生效。",
  "FoodC_subscription_JZaZ_ToBk": "首月仅需支付{{money1}}即可加入{{didipackbrand}}，并开启订阅。您将授权{{didifoodbrand}}于次月自动扣款{{money2}}。可随时取消订阅，取消时无需支付其他费用或罚金。",
  "FoodC_V2_ryoa_JKea": "添加付款方式",
  "FoodC_pause_LiWX_icgn": "您已恢复订阅！",
  "FoodC_membership_fbbI_fyYa": "会员有效期至{{date1}}，{{brand}}将于{{date2}}自动扣费{{money}}以订阅下一期季度会员。您可随时无责取消订阅。",
  "FoodC_pause_pfAh_qUrD": "暂停扣费",
  "FoodD_Gattaran_YoUy_yxOy": "3.获得奖励",
  "FoodC_C_Purchase_Records_CIUH": "购买记录",
  "FoodC_membership_tOCk_ZLUS": "开通按季度订阅",
  "FoodC_bill_dUjM_rVQW": "去下单",
  "FoodC_subscription_arhI_yUex": "继续享受优惠",
  "FoodC_pause_xeiI_PONf": "不需要",
  "FoodC_membership_tatd_NykT": "当前包月会员有效期至{{date1}}，年度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money}}以订阅下一期年度会员。您可随时无责取消订阅。",
  "FoodC_birthday_mwOE_zhiz": "知道了",
  "FoodC_membership_KBOw_KYHp": "您需要现在支付{{money1}}。当前包月会员有效期至{{date1}}，季度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money2}}以订阅下一期季度会员。您可随时无责取消订阅。",
  "FoodC_pause_AtFL_nncW": "订阅暂停",
  "FoodC_didipack_XQlZ_sNjR": "首月仅需支付{{money1}}即可加入{{didipackbrand}}，并开启订阅。您将授权{{didifoodbrand}}于次月自动扣款{{money2}}。可随时取消订阅。",
  "FoodC_update_FzRU_BQMG": "暂停",
  "FoodC_birthday_bthp_qePu": "提交",
  "FoodD_optimization_jCaj_SrWJ": "当前城市暂时没有活动",
  "FoodC_c_Login_for_puGR": "登录查看更多信息",
  "FoodC_C_Coupon_Purchase_zdkl": "券包购买记录",
  "FoodC_pause_cYix_reoR": "{{brand}}将在{{date}}暂停扣费。暂停期间您不会被收取费用也无法享受任何会员权益。",
  "FoodC_1_qiwJ_ERdV": "绑定成功",
  "FoodC_C_Payment_money_XOtx": "支付{{money}}",
  "FoodC_C_Buy_again_ScTm": "{{countdown}}后可再次购买",
  "FoodC_update_mBwf_uAvp": "开始省钱",
  "FoodC_button_Download_DUuD": "下载{{product_name}}",
  "FoodC_update_ZFGk_VVRa": "查看详情",
  "FoodC_CGC_Copy_MtAU": "复制",
  "FoodC_pause_NJOj_iqnX": "会员订阅已暂停。",
  "FoodD_Activity_Single_Step_xtWh": "按单量奖励",
  "FoodC_update_TXai_tCJL": "恭喜您加入{{brand}}",
  "FoodC_membership_dfUx_OawR": "开通按年订阅",
  "FoodC_bill_jWTz_UdyX": "商超",
  "FoodC_update_BIRW_NftU": "免费使用{{brand1}}30天（从{{brand2}}升级）",
  "FoodC_Notifications_Invite_successful_RBjt": "邀请成功用户",
  "FoodC_C_Time_of_LACt": "购买时间",
  "FoodC_cancellation_Ezrs_LhQu": "会员功能正在建设中",
  "FoodC_V2_RlIh_OuIP": "支付方式",
  "FoodC_page_ZTLT_FASC": "如果免配券全部已使用，获得更多免配权益",
  "FoodC_birthday_teJB_YsTQ": "生日：{{date}}",
  "FoodC_birthday_lxme_nZrh": "设置您的生日",
  "FoodC_C_Go_tdhw": "去下单",
  "soda-m-i18n---奖励规则": "Reward Rules",
  "FoodC_shoprank_Qwab_yWBb": "确定",
  "FoodC_membership_AeuK_Curt": "待生效",
  "FoodC_CGC_Cruel_departure_Smts": "残忍离开",
  "FoodC_Promotions_hkSD_CMsv": "条款和条件",
  "FoodC_C_Buy_again_iOeQ": "{{day}}天后可再次购买",
  "FoodC_C_Unlimited_store_Ujro": "利用此促销活动，在下一个订单中节省{{money}}的运费！",
  "FoodC_register_mezq_UlpA": "知道了",
  "FoodC_words_ikBq_XDxq": "加入{{brand}}{{money}}",
  "FoodD_Activity_In_progress_NrnP": "进行中",
  "FoodC_1_Coupon_received_EEkp": "券被领完",
  "FoodC_update_pgdT_nUsj": "预计可省{{money}}",
  "FoodC_C_No_coupon_JTJL": "无可购买券包",
  "FoodC_CGC_Go_and_fnbj": "去领取",
  "FoodC_V2_SvHk_RdVM": "恭喜您已加入{{didipackbrand}}",
  "FoodD_Gattaran_BWwg_jeOR": "一旦您的朋友完成任务，您就可以获得奖励",
  "FoodD_optimization_MkEn_uAUM": "尝试切换城市",
  "FoodC_landingpage_WjPA_dhTE": "复制成功",
  "FoodC_Task_Successfully_received_jXDz": "成功领取{{coupon}}张优惠券。",
  "FoodC_membership_nksN_IHwY": "按{{money}}/年付费",
  "FoodC_saverpack_wepe_hxUg": "可在{{n}}天后再次购买",
  "FoodC_1_Coupon_Account_kcLB": "券账号：{{phone_number}}",
  "DiDi_Food_(C)_Suspended_Delivery_status_Delivery_Pause_PIPS": "暂停配送",
  "FoodC_membership_sKhv_iXXm": "推荐",
  "FoodC_C_Collection_rqwP": "领取",
  "FoodC_subscription_LiqM_lRQw": "DiDi Club",
  "FoodC_V1_Click_receive_fBbu": "点击领取",
  "FoodC_CGC_kRMT_EBEL": "您邀请的好友需通过{{app_name}}下单，通过其他渠道下单不发放邀请奖励",
  "FoodC_C_Universal_Coupon_qLGm": "全场通用券",
  "FoodC_C_Used_tgaq": "已使用",
  "FoodC_C_Only_money_ZEKz": "仅支付{{money}}",
  "FoodC_CGC_QXwb_BKmD": "活动时间{{startdate}}-{{enddate}}",
  "sailing.d-api.common.如何获得奖励": "如何获得奖励",
  "FoodC_member_qXYs_kKZA": "知道了",
  "FoodOpC_Notifications_Full_service_HBkd": "全部服务城市可用",
  "FoodC_membership_hDlN_ORJH": "首月{{money1}}，以后{{money2}}/月",
  "FoodC_C_Expired_AEpg": "已过期",
  "FoodB_Part2_Detailed_description_mxuF": "详细说明",
  "FoodC_CGC__name_Mjiz": "{{name}}获得了{{x}}优惠",
  "FoodC_landingpage_dTIE_JZwU": "复制链接并在浏览器打开以领取spotify会员",
  "FoodC_update_AxFi_uOud": "暂停周期",
  "FoodC_1_zbTm_gzFe": "确定解绑",
  "FoodC_CGC_Invite_immediately_dQRx": "立即邀请",
  "FoodC_241106_qWoj_Vqkc": "您已成功获得{{n}}个月免费的{{brand}}会员！",
  "FoodB_supplement_Network_connection_RVcl": "网络连接失败，请检查网络设置",
  "FoodC_membership_yygL_TGwF": "恭喜您开启年度会员，将从{{date}}起正式生效。",
  "FoodC_membership_uAos_hrFr": "按{{money}}/季度付费",
  "FoodC_page_Rewards_will_NhMd": "奖励会在邀请成功后的48小时内发放入您的账号，您可在{{\t\nproductname_didi_food}}-钱包-券中查看",
  "FoodC_subscription_pODC_SAYm": "已失效",
  "FoodC_membership_iRFJ_WWfs": "会员有效期至{{date1}}，{{brand}}将于{{date2}}自动扣费{{money}}以订阅下一期年度会员。您可随时无责取消订阅。",
  "FoodC_name_99_Takeaway_GFhX": "99外卖用户端",
  "FoodC_Notifications__end_QQPI": "{{end_time}}天后结束",
  "FoodC_1_AeFt_EzNz": "取消",
  "FoodC_page_Upon_discovery_baTq": "一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任",
  "FoodC_C_To_be_Qemy": "待使用",
  "FoodC_V2_syWI_awMo": "信用卡/借记卡",
  "FoodC_CGC_gLdR_yRZb": "一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任",
  "FoodC_button_Open_fmKT": "打开{{product_name}}",
  "FoodC_update_pkbs_cuBj": "您的{{brand}}将在{{date}}结束",
  "FoodC_membership_Pmws_DJul": "您将授权{{brand}}于{{date}}起每季度自动扣款{{money}}。可随时取消订阅，取消时无需支付其他费用或罚金。",
  "FoodD_Activity_Rewards_will_TMCp": "奖励将在活动结束后计入",
  "FoodC_subscription_YJLt_vjMk": "加入{{didipackbrand}}",
  "FoodC_birthday_JshR_FWPW": "日期设置后不可修改",
  "sailing.d-api.common.条款和条件": "条款和条件",
  "FoodB_20230410_YNjt_xAWA": "优选好店",
  "FoodC_birthday_ZEpi_KbUs": "优惠券领取成功",
  "FoodC_pause_VaEr_OWMS": "订阅暂停中",
  "FoodC_didipack_uwFV_TgLK": "加入会员可省{{money}}/月",
  "FoodC_coupons_Congratulations_on_YevG": "恭喜您成功领券",
  "FoodC_Notifications_Invite_user_GtIH": "再邀请{{user_num}}位新用户完成首单，即可得{{gift}}",
  "FoodC_words_MBwE_Wmhg": "第一个月{{money}}",
  "FoodC_birthday_hJRO_UaMS": "领取生日券",
  "soda-b-web-i18n---休息中": "休息中",
  "FoodC_invite_Step_2_AhBV": "第二步：新用户登录并下单成功",
  "FoodC_update_SekQ_qUvj": "订阅费用",
  "FoodC_subscription_RApp_AMMC": "购买{{didipackbrand}}则代表您同意{{rules}}，我们会在每个月的扣款日自动收取{{money}}。可随时无责取消订阅。",
  "FoodC_Notifications_Congratulations_gTCr": "恭喜你",
  "sailing.banner-intl.暂停营业": "暂停营业",
  "FoodC_CGC_xGpr_jdrf": "关于本活动的任何问题，请联系{{app_name}}客服",
  "FoodC_1_Receiving_Records_RumV": "领取记录",
  "FoodC_unsubscription_oSsY_xaBg": "告诉我们更多信息（可选）",
  "FoodC_cancellation_ChTe_NHPP": "剩余{{days}}天",
  "FoodC_page_Invite_friends_oGuj": "邀请好友成为{{\t\nproductname_didi_food}}新用户，好友领取您送出的红包，并在被介绍后14天内及活动时间截止前，完成订单且无退款，无论是否使用领取的红包下单，您均可获得{{\t\nproductname_didi_food}}[优惠券]奖励",
  "FoodC_invite_Step_3_VjuY": "第三步：获得奖励",
  "FoodC_subscription_CtEg_IEoy": "结束订阅{{didipackbrand}}",
  "FoodC_C_You_will_pQqU": "您将获得{{n}}张券",
  "FoodC_subscription_yHJx_Ospz": "有效期：{{date1}}~{{date2}}",
  "FoodC_C_Coupon_Center_WghP": "券包中心",
  "FoodC_1_Unable_to_yqfz": "领取失败",
  "FoodC_V1_Use_IuaW": "去使用",
  "FoodC_page_This_special_fYuo": "本优惠活动仅限{{\t\nactivity_city}}开通{{\t\nproductname_didi_food}}区域",
  "FoodC_page_For_any_IWNZ": "关于本活动的任何问题，请联系{{contact_email}}客服",
  "FoodC_update_RaYq_YNqC": "订阅信息",
  "FoodD_Activity_Expand_more_VNNc": "展开更多",
  "FoodC_words_bshC_QpQz": "加入{{brand}}第一个月{{money}}",
  "FoodC_unsubscription_PWOD_DyeO": "您已成功开启订阅！",
  "FoodC_C_Terms_and_eAhU": "条款和条件",
  "FoodC_saverpack_GjXC_jBNu": "{{n}}张券可使用",
  "FoodC_membership_BIGZ_CvrZ": "按年",
  "FoodC_pause_aidJ_DeYv": "您已取消订阅。",
  "FoodC_membership_StFc_NVHY": "当前包月会员有效期至{{date1}}，半年度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money}}以订阅下一期半年度会员。您可随时无责取消订阅。",
  "FoodC_update_lgoe_CKtm": "免费",
  "FoodC_C_Invitation_CPGR": "邀请",
  "FoodC_membership_MEEh_ctts": "开通按年订阅",
  "FoodC_c_Please_log_pWNK": "请登录您的账号",
  "FoodC_subscription_eceZ_mHfd": "下一次续订时间为{{date}}，自动扣款金额为{{money}}。可随时取消订阅，取消时无需支付其他费用或罚金。",
  "FoodD_optimization_KHwe_UDpu": "所有记录",
  "FoodC_didipack_kIYJ_MqHw": "您将授权{{didifoodbrand}}于次月自动扣款{{money2}}。可随时取消订阅。",
  "FoodC_invite_Step_1_IIde": "第一步：邀请新用户",
  "FoodC_V1_View_activity_NCOP": "查看其它活动",
  "FoodD_Gattaran_Tfhf_xZxX": "分享您的专属邀请链接，或请被邀请人在注册时填写您的专属邀请码完成注册。请注意被推荐人需要在注册有效期内完成注册。此外推荐人需要通过合规审核才可以参与推荐活动。",
  "FoodC_1_tSXl_EXCL": "绑定账户",
  "FoodD_Activity_Number_of_vXPs": "按人数奖励",
  "FoodC_bill_qjez_JBnr": "出行",
  "FoodC_c_Unable_to_cPrS": "无法连接服务",
  "FoodC_C_Back_Home_opQY": "回首页",
  "FoodD_optimization_Qqcn_TvQv": "当前活动无邀请记录，可点击右上角查询历史记录",
  "FoodC_cancellation_kNom_uYlR": "订阅中",
  "FoodD_optimization_pADD_hRLc": "其他",
  "FoodC_copyaddJP_Your_mobile_zrXT": "您的手机号码将仅用于绑定本次活动所获得的券，请放心填写",
  "FoodC_member_wEQc_Appv": "您已在当前订单中选择购买了{{brand}}，完成订单即可加入！",
  "FoodC_membership_Cmcr_KOyO": "开通按半年订阅",
  "FoodC_Notifications_Rewards_received_czXX": "获得的奖励",
  "sailing.d-api.common.其他说明": "其他说明",
  "FoodC_membership_aBDt_VhkX": "会员有效期至{{date1}}，{{brand}}将于{{date2}}自动扣费{{money}}以订阅下一期半年度会员。您可随时无责取消订阅。",
  "soda-m-i18n---完成": "Complete",
  "FoodC_all_You_haven_lSmt": "你还没有邀请你的朋友，快去邀请他们吧",
  "FoodC_Notifications_Accept_the_wTgP": "接受邀请",
  "FoodC_cancellation_hxiG_guHC": "订阅已暂停",
  "FoodC_1_UGRq_VTHx": "输入你的会员账号",
  "FoodC_pause_dEKK_qnxf": "会员自动扣费已暂停，会员权益从{{date1}}起{{num}}个月内无法使用。您将在{{date2}}重新加入{{brand}}并被自动扣款{{money}}。{{tc}}",
  "FoodC_subscription_KlqY_fMjr": "生效中",
  "FoodC_member_fKsy_UJNP": "查看订单",
  "FoodC_C_Use_jLVF": "使用",
  "FoodC_birthday_MdbO_KlNx": "设置生日",
  "FoodC_C__n_tBvE": "{{n}}张券",
  "FoodC_campaign_RqSl_PwEk": "本优惠活动仅限{{99Food}}的订单享受，不可提现转赠",
  "FoodD_optimization_rIEQ_UWUa": "分享",
  "FoodD_Gattaran_jMrz_rmga": "2.被推荐人完单",
  "FoodC_C_Maximum_deduction_UvNt": "最高抵扣{{money}}",
  "FoodC_CGC_There_is_gZQn": "还有{{x}}金额待领取",
  "FoodC_update_PQxd_TDOz": "开通{{brand}}并下单！开启省钱之旅。",
  "FoodC_member_rIZz_EbdA": "会员购买中",
  "FoodC_CGC_JFyK_TjqE": "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用",
  "FoodC_subscription_XfQl_RWPP": "订阅功能",
  "FoodC_saverpack_DPys_ZTjB": "规则",
  "FoodC_bill_MFfk_WhCz": "省了",
  "FoodC_c_Try_again_lIZQ": "重试",
  "FoodC_1_gJQN_sqIt": "解绑会员账号",
  "FoodC_unsubscription_qlCR_GqbU": "取消订阅",
  "FoodC_birthday_vcey_tequ": "查看优惠券",
  "FoodC_update_FOFJ_UkRW": "无限次出行5%off",
  "FoodC_membership_ghra_QaCb": "您需要现在支付{{money1}}。当前包月会员有效期至{{date1}}，半年度会员从{{date2}}开始，并将于{{date3}}自动扣费{{money2}}以订阅下一期半年度会员。您可随时无责取消订阅。",
  "FoodC_page_hbyT_BKde": "免配送",
  "FoodC_C_Coupon_package_aeUS": "券包",
  "FoodC_subscription_HZKf_jObw": "您未开通订阅",
  "FoodC_membership_CHIm_nRPw": "按{{money}}/半年付费",
  "FoodC_saverpack_slen_UJLn": "您将获得{{n}}张券，用完即省{{money}}！无需订阅。",
  "FoodD_optimization_hPwx_hGCS": "历史",
  "FoodC_subscription_Jnyy_Zokk": "{{didipackbrand}}正在续费中，请稍后回来",
  "soda-m-i18n---取消": "Cancel",
  "FoodC_C_More_TIyU": "更多",
  "FoodC_campaign_aFBJ_ipZl": "奖励会在邀请成功后的{{num}}小时内发放入您的账号，您可在{{99Food}}的券列表页中查看",
  "FoodC_1_Additional_Surprise_bBNh": "新用户额外惊喜奖励",
  "FoodC_C_Up_to_boqc": "--",
  "FoodC_V2_NigJ_XaWd": "订阅{{didipackbrand}}",
  "FoodC_update_iSQF_topi": "无限次外卖免服务费",
  "FoodD_Gattaran_seSn_keOw": "指导您的朋友在任务期内完成任务要求的订单数量",
  "FoodC_update_rJfl_rGTF": "免服务费",
  "FoodC_STORE_sDEb_djsn": "排行榜",
  "FoodC_subscription_Wlpe_bBkf": "购买记录",
  "sailing.act-api-intl.活动已经结束": "活动已经结束",
  "FoodC_membership_WgGp_puVL": "您将授权{{brand}}于{{date}}起每半年自动扣款{{money}}。可随时取消订阅，取消时无需支付其他费用或罚金。",
  "FoodC_419_zBRR_jLNF": "没有门槛限制",
  "FoodC_C_No_purchase_cMRq": "无购买记录",
  "FoodC_C_Full_money_oqcE": "满{{money}}可用",
  "FoodC_update_fIEP_oDcY": "升级",
  "FoodC_unsubscription_tnHb_xMuO": "下一步",
  "FoodC_C_You_have_EjAA": "您已获得",
  "FoodC_update_ZTvS_WSTC": "免配送",
  "FoodD_Activity_No_activity_fhqd": "暂无活动参与记录",
  "FoodC_V2_qWhb_IjVg": "订阅",
  "FoodC_update_fyhl_EPiz": "出行订单5%off优惠",
  "FoodC_didipack_ruhC_zsFU": "支付{{money}}加入{{didipack}}",
  "FoodC_CGC_PFoL_QAIo": "单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付",
  "FoodC_pause_qsCr_nszu": "恢复订阅",
  "FoodC_CGC_wkuZ_BrqU": "奖励按照【被推荐人】定位所在城市发放",
  "FoodC_register_WoRy_tjec": "请选择支付方式",
  "Gattaran_reffral_Kjwv_iVSZ": "邀请好友",
  "FoodC_Notifications_Completed_pEhY": "已完成",
  "FoodC_cash_wnPC_qiCD": "去使用",
  "FoodC_update_VTVc_ZtNA": "之后",
  "FoodC_landingpage_mibx_wmgS": "复制",
  "FoodC_C_Purchase_amount_RXkR": "购买金额",
  "FoodC_1_wrbv_ghhe": "请输入有效的会员账号",
  "FoodC_subscription_uoAf_TiHz": "感谢您使用{{didipackbrand}}，结束订阅后，{{didipackbrand}}权益将于{{date}}结束，确定要取消订阅吗？",
  "FoodC_update_xiIf_xSte": "基础信息",
  "FoodC_C_Mission_expired_vxOU": "当前没有正在进行的任务",
  "FoodC_subscription_QaXu_EIIa": "管理{{didipackbrand}}",
  "FoodC_C_My_coupon_fmaV": "我的优惠券",
  "FoodC_V2_SSNq_tsZF": "知道了",
  "FoodC_subscription_VPMP_seXT": "规则与条款",
  "FoodC_subscription_jyMF_Ybuq": "你正在享受{{brand}}的免费试用。如果现在取消订阅，你将立即失去免费试用资格，并且无法享受外卖免配送费和其他会员权益。",
  "FoodC_1_biry_lDbX": "解绑成功",
  "FoodC_C_Order_assignments_xxGZ": "下单任务",
  "FoodC_cancellation_NLzA_tDER": "会员功能尚未覆盖您所在的国家，谢谢您的关注与支持。",
  "FoodC_subscription_DzKZ_WhvD": "购买时间:{{date}}",
  "FoodC_1_Share_it_scKc": "分享给朋友，一起享优惠吧！",
  "FoodC_bill_zfEm_MWKg": "外卖",
  "FoodD_Activity_Single_reward_ZrZS": "单数奖励",
  "FoodC_CGC_has_successfully_CrTW": "已经成功邀请了{{x}}个朋友",
  "FoodC_update_TDwr_XZVd": "我的{{brand2}}",
  "FoodC_update_LeTO_aqit": "会员权益",
  "FoodC_all_No_reward_ocGJ": "没有奖励",
  "FoodC_membership_urwF_ywDu": "您将授权{{brand}}于{{date}}起每年自动扣款{{money}}。可随时取消订阅，取消时无需支付其他费用或罚金。",
  "FoodC_1_Everyone_is_Tdgu": "大家都在领取奖励",
  "FoodC_CGC_UFif_hfJM": "奖励会在邀请成功后的{{num}}小时内发放入您的账号，您可在{{app_name}}-钱包-券中查看",
  "FoodC_C_Go_VWzj": "去下单",
  "FoodC_toast__SVYJ": "领取成功",
  "FoodC_C_The_end_yvSK": "截止至",
  "FoodC_center_Ospi_SNsH": "累计已省",
  "FoodC_page_eUPd_sDHg": "规则",
  "FoodC_cancellation_JZXv_OcQW": "取消订阅",
  "sailing.d-api.common.活动疑问请联系": "活动疑问请联系",
  "FoodD_Activity_Number_of_OgKt": "人数奖励",
  "FoodC_pause_tfPj_IAoM": "您将在{{date}}重新加入{{brand}}并被自动扣款{{money}}。{{tc}}",
  "soda-d-i18n---无任何记录": "无任何记录",
  "FoodC_C_Bonded_package_lroO": "券包市场",
  "当前无活动": "当前无活动",
  "该城市暂无活动": "该城市暂无活动",
  "取消": "取消",
  "网络异常，请稍后再试": "网络异常，请稍后再试",
  "手机号码错误": "手机号码错误",
  "选择国家或地区": "选择国家或地区",
  "暂时不需要%s的服务": "暂时不需要%s的服务",
  "支付成功": "支付成功",
  "我们正在努力": "我们正在努力",
  "是，半年之内不要给我发邮件": "是，半年之内不要给我发邮件",
  "将优惠分享到": "将优惠分享到",
  "邮件退订结果": "邮件退订结果",
  "暂无活动": "暂无活动",
  "推荐记录": "推荐记录",
  "恭喜你获得%s张优惠券，快去使用吧": "恭喜你获得%s张优惠券，快去使用吧",
  "X推D": "X推D",
  "X推C": "X推C",
  "不支持现金支付": "不支持现金支付",
  "该浏览器不支持自动复制": "该浏览器不支持自动复制",
  "对此类邮件不感兴趣": "对此类邮件不感兴趣",
  "退订理由：": "退订理由：",
  "登录": "登录",
  "输入手机号码获取优惠券": "输入手机号码获取优惠券",
  "现金": "现金",
  "仅限%s": "仅限%s",
  "规则详情": "规则详情",
  "您邀请的好友需通过%s下单，通过其他渠道下单不发放邀请奖励": "你邀请的好友需通过%s下单，通过其他渠道下单不发放邀请奖励",
  "折": "折",
  "是，再也不要给我发邮件了": "是，再也不要给我发邮件了",
  "输入手机号": "输入手机号",
  "在这里购买！": "点击购买！",
  "阶梯奖励": "阶梯奖励",
  "很遗憾，未能领取成功": "很遗憾，未能领取成功",
  "活动时间": "活动时间",
  "隐藏": "隐藏",
  "%s可用": "%s可用",
  "满%s可用": "满%s可用",
  "T&C": "法律声明",
  "售罄": "售罄",
  "当前定位城市：": "当前定位城市：",
  "券包": "券包",
  "附近没有商家": "附近没有商家",
  "请登录": "请登录",
  "选择城市": "选择城市",
  "您已经成功领取优惠券": "你已经成功领取优惠券",
  "兑换成功": "兑换成功",
  "更多详情": "更多详情",
  "可获得%s优惠券": "可获得%s优惠券",
  "轻松来获得一个非常棒的优惠券包": "轻松来获得一个非常棒的优惠券包",
  "请开启定位": "请开启定位",
  "支付超时！": "支付超时！",
  "奖励会在邀请成功后的48小时内发放入您的账号，您可在%s-钱包-券中查看": "奖励会在邀请成功后的48小时内发放入你的账号，你可在%s-钱包-券中查看",
  "去升级": "去升级",
  "复制成功": "复制成功",
  "免配送费": "免配送费",
  "重新加载": "重新加载",
  "支付": "支付",
  "%s日内有效": "%s日内有效",
  "有效时间:": "有效时间:",
  "当前无有效活动": "当前无有效活动",
  "周四": "周四",
  "本优惠活动仅限%s[在线支付]的订单享受，不可提现转赠": "本优惠活动仅限%s[在线支付]的订单享受，不可提现转赠",
  "通过SNS邀请": "通过SNS邀请",
  "分钟": "分钟",
  "恭喜你！兑换成功！": "恭喜你！兑换成功！",
  "优惠券中心": "优惠券中心",
  "我的优惠券": "我的优惠券",
  "网络繁忙，请稍后再试": "网络繁忙，请稍后再试",
  "很遗憾您无法接收我们的最新消息了，感谢您使用%s！": "很遗憾你无法接收我们的最新消息了，感谢你使用%s！",
  "奖励进度": "奖励进度",
  "领取成功": "领取成功",
  "周五": "周五",
  "周二": "周二",
  "券包购买已超限制": "券包购买已超限制",
  "与": "与",
  "最高抵扣%s": "最高抵扣%s",
  "您邀请的好友必须是%s新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户": "你邀请的好友必须是%s新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户",
  "邮件频率过高": "邮件频率过高",
  "收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码": "收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码",
  "当前手机系统不支持自动复制": "当前手机系统不支持自动复制",
  "仅售": "仅售",
  "兑换优惠券": "兑换优惠券",
  "收起": "收起",
  "大家都在领取奖励": "大家都在领取奖励",
  "配送费": "配送费",
  "支付中": "支付中",
  "在您的订单中使用这些优惠！": "在你的订单中使用这些优惠！",
  "已获得奖励": "已获得奖励",
  "SMS": "SMS",
  "恭喜你获得一张%s优惠券，快去使用吧": "恭喜你获得一张%s优惠券，快去使用吧",
  "复制": "复制",
  "我知道了": "我知道了",
  "《法律声明与隐私政策》": "《法律声明与隐私政策》",
  "OFF": "OFF",
  "兑换中": "兑换中",
  "周三": "周三",
  "已参与过同类型活动</br>快去下单吧": "已参与过同类型活动</br>快去下单吧",
  "看看其他的活动": "看看其他的活动",
  "周一": "周一",
  "隐私政策》": "隐私政策》",
  "推荐有奖": "推荐有奖",
  "同意": "同意",
  "周日": "周日",
  "在购买后的一个月内都可以使用": "在购买后的一个月内都可以使用",
  "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用": "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用",
  "邮件退订": "邮件退订",
  "输入兑换码": "输入兑换码",
  "详细规则": "详细规则",
  "Share": "Share",
  "你已经打开过这个礼盒了": "你已经打开过这个礼盒了",
  "知道了": "知道了",
  "运营活动": "运营活动",
  "定位服务未开启，需要先开启定位服务才能参与活动！": "定位服务未开启，需要先开启定位服务才能参与活动！",
  "购买": "购买",
  "券账号：%s": "券账号：%s",
  "查看其它活动": "查看其它活动",
  "新用户额外惊喜奖励": "新用户额外惊喜奖励",
  "%s天后过期": "%s天后过期",
  "单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付": "单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付",
  "可抵扣%s": "可抵扣%s",
  "仅限%s使用": "仅限%s使用",
  "领取记录": "领取记录",
  "立即兑换": "立即兑换",
  "如果您退订邮件，可能会错过重要消息，您确定不再接收%s给您发送的邮件吗？": "如果你退订邮件，可能会错过重要消息，你确定不再接收这些邮件吗？",
  "周六": "周六",
  "待入账": "待入账",
  "点击领取": "点击领取",
  "落地页": "落地页",
  "C运营弹窗": "C运营弹窗",
  "POS": "POS",
  "添加信用卡/借记卡": "添加信用卡/借记卡",
  "活动说明": "活动说明",
  "Email": "Email",
  "领取失败": "领取失败",
  "网络似乎存在问题，请稍后重试": "网络似乎存在问题，请稍后重试",
  "分享给朋友，一起享优惠吧！": "分享给朋友，一起享优惠吧！",
  "《法律声明": "《法律声明和",
  "当日有效": "当日有效",
  "有效期至": "有效期至",
  "支付方式": "支付方式",
  "邀请": "邀请",
  "等待支付结果": "等待支付结果",
  "应付金额": "应付金额",
  "购买含4张$10mxn无门槛券的优惠券包仅需支付$20mxn": "购买含4张$10mxn无门槛券的优惠券包仅需支付$20mxn",
  "是，一年之内不要给我发邮件": "是，一年之内不要给我发邮件",
  "仅限新用户使用": "仅限新用户使用",
  "一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任": "任何违规、套现行为，一经发现，将追回相关金额或者封停账号，且依法追究其法律责任",
  "退订": "退订",
  "网络不佳，请检查您的网络": "网络不佳，请检查你的网络",
  "重试": "重试",
  "查看更多": "查看更多",
  "请选择支付方式": "请选择支付方式",
  "%s 人": "%s 人",
  "我的邀请码": "我的邀请码",
  "获取优惠券": "获取优惠券",
  "我的奖励": "我的奖励",
  "C端落地页": "C端落地页",
  "兑换失败": "兑换失败",
  "待入账奖励": "待入账奖励",
  "加载失败": "加载失败",
  "必须同意用户条款，才能继续下一步": "必须同意用户条款，才能继续下一步",
  "附近商家": "附近商家",
  "暂无优惠券": "暂无优惠券",
  "卡类型": "卡类型",
  "格式不正确": "格式不正确",
  "订单": "订单",
  "不可用原因": "不可用原因",
  "请您升级到最新的APP版本，体验外卖功能": "请你升级到最新的APP版本，体验外卖功能",
  "邀请一个好友即可获得": "邀请一个好友即可获得",
  "返回首页": "返回首页",
  "没有更多了": "没有更多了",
  "去预订食物": "去预订食物",
  "More": "More",
  "有效期至%s": "有效期至%s",
  "去看看": "去看看",
  "兑换失败，请再试一次": "兑换失败，请再试一次",
  "确认": "确认",
  "已过期": "已过期",
  "本优惠活动仅限[%s]开通%s区域": "本优惠活动仅限[%s]开通%s区域",
  "此活动尚未在您的城市开通": "此活动尚未在你的城市开通",
  "确定": "确定",
  "去使用": "去使用",
  "%s": "%s",
  "当天过期": "当天过期",
  "去看看其他的": "去看看其他的",
  "具体活动规则见": "具体活动规则见",
  "条款和条件": "法律声明",
  "配送": "配送",
  "为你的第一单领取优惠": "为你的第一单领取优惠",
  "通用支付": "通用支付",
  "99Pay-余额": "99Pay-余额",
  "券被领完": "券被领完",
  "卡": "卡",
  "优惠券已放入": "优惠券已放入",
  "关于本活动的任何问题，请联系%s客服": "关于本活动的任何问题，请联系%s客服",
  "邀请好友成为%s新用户，好友领取您送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，您均可获得%s[优惠券]奖励": "邀请好友成为%s新用户，好友领取你送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，你均可获得%s[优惠券]奖励",
  "推荐骑手": "推荐骑手",
  "活动已结束": "活动已结束",
  "今日领取次数达上限": "今日领取次数达上限"
}